module.exports = __webpack_public_path__ + "img/teacher_1.97ab68bd.png";